import { render, staticRenderFns } from "./createPost.vue?vue&type=template&id=73aa1032&scoped=true&"
import script from "./createPost.vue?vue&type=script&lang=js&"
export * from "./createPost.vue?vue&type=script&lang=js&"
import style0 from "./createPost.vue?vue&type=style&index=0&id=73aa1032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa1032",
  null
  
)

export default component.exports